const mainurl = 'https://www.admin.gibnu.com'

const ServerData = {
    'uri':`${mainurl}/vendorapi`,
    'uri2':`${mainurl}/userapi`,
    'uri3':`${mainurl}/agentapi`,
    'admin':`${mainurl}/adminapi`,
}

export default ServerData